import ReactDefaultProps from 'views/main/react/ReactDefaultProps';
import { fetchMultipleUserSocialProfileImage } from 'actions/userSocialProfileImageActions';

/**
 * This object use ReactDefaulProps.store (that is shared through all ReactComponentView) to dispatch action that triggers avatar(profile image) fetching.
 * ideally this wasn't need. but redux and backbone don't coop really well
 * */
const AvatarRefreshInstance = {
    triggerRefresh: function(viewerProfileId) {
        if (!ReactDefaultProps.store || typeof ReactDefaultProps.store.dispatch !== 'function') {
            return;
        }
        ReactDefaultProps.store.dispatch(fetchMultipleUserSocialProfileImage([viewerProfileId], true));
    }
};

export default AvatarRefreshInstance;
